import * as React from "react";
import PropTypes from "prop-types";
import {useTheme} from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import {Card, Divider, Grid, InputLabel, Typography} from "@mui/material";
import LMS_Flow from "../../assets/LMS_Flow.pdf";
import MDButton from "components/MDButton";
import properties from "constants/ApplicationConstants";

export default function LMSPolicyDocuments() {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  //   const handleChange = (event, newValue) => {
  //     setValue(newValue);
  //   };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <AppBar position="static">
          <MDBox mt={6} mb={3}>
            <Grid container spacing={3} justifyContent="center">
              <Grid item xs={12} lg={8}>
                <Card container>
                  <MDBox p={2}>
                    <Typography variant="h5" fontFamily={properties.fontFamily}>
                      Company Policy
                    </Typography>
                  </MDBox>
                  <MDBox pt={4} pb={3} px={3}>
                    <InputLabel
                      sx={{fontWeight: "bold", fontFamily: properties.fontFamily}}
                      id="bonus"
                      mb={2}
                    >
                      LMS Policy Document
                    </InputLabel>
                  </MDBox>
                  <Divider />

                  <MDBox mt={2} mb={4} gap={1.5}>
                    <MDBox
                      component="ul"
                      sx={({breakpoints}) => ({
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "end",
                        justifyContent: "center",
                        listStyle: "none",
                        mt: 3,
                        mb: 0,
                        p: 0,
                        gap: 2,
                        [breakpoints.up("lg")]: {
                          mt: 0
                        }
                      })}
                    >
                      <MDButton
                        variant="gradient"
                        color="info"
                        sx={{background: properties.colors.bgcolorbluethem}}
                        href={LMS_Flow}
                        target="_blank"
                      >
                        View Policy
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
        </AppBar>
      </MDBox>
    </DashboardLayout>
  );
}
